<template>
  <i
    v-tooltip="tooltip"
    class="
      fa fa-check
      tw-ring-inset
      tw-ring
      tw-ring-offset-1
      tw-rounded-full
      tw-w-8
      tw-h-8
      tw-p-2
      tw-flex
      tw-items-center
      tw-justify-center
      tw-text-base
      tw-leading-4
    "
    :class="iconClasses"
    data-testid="todo-toggle"
    @click.prevent="handleClick"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { commsTheme } from '@app/shared/comms-theme'

const I18n = useI18n()
const theme = commsTheme()
const emit = defineEmits<{ toggle: [] }>()

interface Props {
  done: boolean
  canEdit: boolean
}

const props = withDefaults(defineProps<Props>(), {
  done: () => false,
  canEdit: () => false,
})

const tooltip = computed(() =>
  props.canEdit ? I18n.t(`communication.todos.toggle.${props.done}`) : ''
)

const iconClasses = computed(() => ({
  'tw-cursor-pointer': props.canEdit,
  [theme.todoRing]: props.canEdit,
  [theme.todoRingOffset]: props.canEdit,
  [theme.todoRingOffsetHover]: props.canEdit,
  [theme.todoRingLocked]: !props.canEdit,
  [theme.todoRingOffsetLocked]: !props.canEdit,
  [theme.todoCheck]: props.done,
  'tw-text-transparent': !props.done,
  'tw-bg-sf-success-light-1': props.done && props.canEdit,
  [theme.todoFill]: !props.done,
  'hover:tw-bg-sf-success-light-2': props.done && props.canEdit,
  [theme.todoFillDoneLocked]: props.done && !props.canEdit,
  'hover:tw-text-sf-success-light-1': !props.done && props.canEdit,
}))

function handleClick() {
  if (props.canEdit) {
    emit('toggle')
  }
}
</script>
